import styled from 'styled-components';

const StyledQuickFilterWrapper = styled.div`
  display: none;

  @media ${(props) => props.theme.mediaQuery.large} {
    display: flex;
    width: auto;
  }

  ${({ isPLPSortAndOneHrFilterRedesignEnabled }) =>
    isPLPSortAndOneHrFilterRedesignEnabled && 'width:auto; flex-shrink:0;'}
`;

export default StyledQuickFilterWrapper;
